"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _Forgot = _interopRequireDefault(require("../pages/Forgot"));
var _Login = _interopRequireDefault(require("../pages/Login"));
var _Launch = _interopRequireDefault(require("../pages/Launch"));
var _Profile = _interopRequireDefault(require("../pages/Profile"));
var _Reset = _interopRequireDefault(require("../pages/Reset"));
var _AzureAuthorizationCodeRedirect = _interopRequireDefault(require("../pages/azure/AzureAuthorizationCodeRedirect"));
var _Recovery = _interopRequireDefault(require("../layout/footer/Recovery"));
var _SiteMaintenance = _interopRequireDefault(require("../layout/footer/SiteMaintenance"));
var _Legal = _interopRequireDefault(require("../layout/footer/Legal"));
var _PrivacyPolicy = _interopRequireDefault(require("../layout/footer/PrivacyPolicy"));
var _SiteRequirements = _interopRequireDefault(require("../layout/footer/SiteRequirements"));
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _ApplicationContext = require("../api/ApplicationContext");
var _OAuthLaunch = _interopRequireDefault(require("../pages/OAuthLaunch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const closeModal = props => {
  const currentPathname = props.location.pathname;
  const {
    logoutPath,
    loginPath
  } = props;
  if (currentPathname === logoutPath) {
    props.history.push(loginPath);
    return;
  }
  props.history.goBack();
  if (currentPathname === props.location.pathname) {
    props.history.push(loginPath);
  }
};
const FooterRoutes = props => [/*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  key: "route_footer_rec",
  path: "/recovery.html",
  render: () => /*#__PURE__*/_react.default.createElement(_Recovery.default, _extends({}, props, {
    closeModal: closeModal,
    isShow: true
  }))
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  key: "route_footer_sitemaint",
  path: "/siteMaintenance.html",
  render: () => /*#__PURE__*/_react.default.createElement(_SiteMaintenance.default, _extends({}, props, {
    closeModal: closeModal,
    isShow: true
  }))
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  key: "route_footer_sitereq",
  path: "/siteRequirement.html",
  render: () => /*#__PURE__*/_react.default.createElement(_SiteRequirements.default, _extends({}, props, {
    closeModal: closeModal,
    isShow: true
  }))
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  key: "route_footer_leg",
  path: "/legal.html",
  render: () => /*#__PURE__*/_react.default.createElement(_Legal.default, _extends({}, props, {
    closeModal: closeModal,
    isShow: true
  }))
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  key: "route_footer_priv",
  path: "/privacy.html",
  render: () => /*#__PURE__*/_react.default.createElement(_PrivacyPolicy.default, _extends({}, props, {
    closeModal: closeModal,
    isShow: true
  }))
})];
const SecurityRoutes = props => {
  const {
    logoutPath = _ApplicationContext.ApplicationContext.getLogoutPath(),
    loginPath = _ApplicationContext.ApplicationContext.getLoginPath(),
    launchPath = '/launch',
    launchErrorPath = '/launch/401',
    superUserloginPath = '/account_support/login.html',
    marketingReploginPath = '/sales/login.html',
    forgotPath = '/forgot.html',
    resetAccountPath = '/resetAccount.html',
    resetPasswordPath = '/resetPassword.html',
    profilePath = _ApplicationContext.ApplicationContext.getProfilePath(),
    azureRedirectPath = '/login/oauth2/code/',
    oauthAuthorizationPath = '/oauth/authorize',
    profile: CustomProfile
  } = props;
  const routes = [];
  const logoutSuccessPath = _ApplicationContext.ApplicationContext.getOverrideDefaultPath();
  const logoutProps = logoutSuccessPath ? {
    logoutSuccessPath,
    ...props
  } : {
    ...props
  };
  routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    key: "route_logout",
    path: logoutPath,
    render: () => /*#__PURE__*/_react.default.createElement(_Login.default, _extends({}, logoutProps, {
      isFromLogout: true
    }))
  }));
  routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    key: "route_azureRedirect",
    path: azureRedirectPath,
    render: () => /*#__PURE__*/_react.default.createElement(_AzureAuthorizationCodeRedirect.default, props)
  }));
  routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    key: "route_oauthAuthorize",
    path: oauthAuthorizationPath,
    render: () => /*#__PURE__*/_react.default.createElement(_OAuthLaunch.default, props)
  }));
  if (_ApplicationContext.ApplicationContext.isProfile()) {
    routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      key: "route_profile",
      path: profilePath,
      render: () => CustomProfile ? /*#__PURE__*/_react.default.createElement("div", {
        className: "custom-profile-container"
      }, CustomProfile) : /*#__PURE__*/_react.default.createElement(_Profile.default, props)
    }));
  }
  if (!_SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
    if (_ApplicationContext.ApplicationContext.isRunAs()) {
      routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "superuser_route_login",
        path: superUserloginPath,
        render: () => /*#__PURE__*/_react.default.createElement(_Login.default, _extends({}, props, {
          isFromSuperUser: true,
          isFromMarketingRep: false
        }))
      }));
    }
    if (_ApplicationContext.ApplicationContext.isMarketingRep()) {
      routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "marketingrep_route_login",
        path: marketingReploginPath,
        render: () => /*#__PURE__*/_react.default.createElement(_Login.default, _extends({}, props, {
          isFromSuperUser: false,
          isFromMarketingRep: true
        }))
      }));
    }
    if (_ApplicationContext.ApplicationContext.isWebUserReset()) {
      routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "route_reset_account",
        path: resetAccountPath,
        render: () => /*#__PURE__*/_react.default.createElement(_Reset.default, _extends({}, props, {
          isFromSuperUser: false,
          isFromMarketingRep: false
        }))
      }));
      routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "route_reset_password",
        path: resetPasswordPath,
        render: () => /*#__PURE__*/_react.default.createElement(_Reset.default, _extends({}, props, {
          isFromSuperUser: false,
          isFromMarketingRep: false
        }))
      }));
      routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: "route_forgot",
        path: forgotPath,
        render: () => /*#__PURE__*/_react.default.createElement(_Forgot.default, _extends({}, props, {
          isFromSuperUser: false,
          isFromMarketingRep: false
        }))
      }));
    }
    routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      key: "route_login",
      path: loginPath,
      render: () => /*#__PURE__*/_react.default.createElement(_Login.default, _extends({}, props, {
        isFromSuperUser: false,
        isFromMarketingRep: false
      }))
    }));
  }
  if (_ApplicationContext.ApplicationContext.isLaunchToken() || _ApplicationContext.ApplicationContext.getDefaultLoginMethod() === 'token') {
    routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      key: "route_launch",
      path: launchPath,
      render: () => /*#__PURE__*/_react.default.createElement(_Launch.default, _extends({}, props, {
        isFromSuperUser: false,
        isFromMarketingRep: false
      }))
    }));
  }
  routes.push(...FooterRoutes(props));
  if (!_SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
    if (window.location.pathname !== loginPath && window.location.pathname !== logoutPath && window.location.pathname !== launchPath && window.location.pathname !== azureRedirectPath) {
      if (_ApplicationContext.ApplicationContext.getOverrideDefaultPath()) {
        routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "route_redirect",
          render: () => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
            to: {
              pathname: _ApplicationContext.ApplicationContext.getOverrideDefaultPath(),
              search: window.location.search
            },
            push: true
          })
        }));
      } else if (_ApplicationContext.ApplicationContext.getDefaultLoginMethod() === 'token') {
        routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "route_redirect",
          render: () => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
            to: {
              pathname: launchErrorPath,
              search: window.location.search
            },
            push: true
          })
        }));
      } else if (props.site?.public?.defaultPath) {
        if (props.site?.public?.siteMenu) {
          routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
            key: "route_redirect",
            render: () => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
              to: {
                pathname: props.site.public.defaultPath,
                search: window.location.search
              },
              push: true
            })
          }));
        }
      } else {
        routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          key: "route_redirect",
          render: () => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
            to: {
              pathname: loginPath,
              search: window.location.search,
              state: {
                returnUrl: window.location.pathname
              }
            },
            push: true
          })
        }));
      }
    }
  }
  return routes;
};
SecurityRoutes.propTypes = {
  launchErrorPath: _propTypes.default.string,
  launchPath: _propTypes.default.string,
  loginPath: _propTypes.default.string,
  logoutPath: _propTypes.default.string,
  forgotPath: _propTypes.default.string,
  resetPath: _propTypes.default.string,
  profilePath: _propTypes.default.string,
  CustomProfile: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object])
};
var _default = exports.default = SecurityRoutes;
//# sourceMappingURL=SecurityRoutes.js.map